import React, { useEffect } from 'react';
import queryString from 'query-string';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'Ecuanet - Iniciar Sesión';
    document.body.className = 'ecuanet-body';
  });

  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const validateParams = () =>
    parameters.client_id && parameters.redirect_uri && parameters.response_type;

  return (
    <div className="ecuanet-page">
      {validateParams() ? (
        <LoginForm api={api} location={location} />
      ) : (
        <RequestLoginErrorMessage
          onlyMessage={true}
          message={translate('RequestLoginErrorMessage')}
        />
      )}
    </div>
  );
};

export default Login;
